import { BaseApiRequest } from "../../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { ReverseRelation } from "@robe/core-types";

export const getReverseRelations = (contentId: number, core: XcoreCore): BaseApiRequest<Array<ReverseRelation>> =>
  core.fetch(`/api/content/reverse-relations/${contentId}`).then((res) => res.json());
